export default{
    section:'بخش',
    tendernessWithTheProbeTypesTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    tendernessWithTheProbeTypes:'Tenderness With The Probe Types',
    editTendernessWithTheProbeTypes:'ویرایش Tenderness With The Probe Types',
    addTendernessWithTheProbeTypes : 'Tenderness With The Probe Types جدید',
}